import React, { useState } from "react";
import { schema } from "./validator";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useHistory } from "react-router-dom";

import { FormField } from "../../../ui-kit/FormField/FormField";
import { IButton } from "../../../ui-kit/IButton/IButton";
import Api from "../../../api/Auth";

import styles from "../LoginForm/LoginForm.module.scss";
import { useStatusMessage } from "../../../hooks/useStatusMessage";
import { authStore } from "../../../store/authStore";
import { observer } from "mobx-react-lite";
import { LogoDarkLetters } from "../../../assets/customIcons";

export interface IForgotPasswordForm {
  email: string;
}

export const ForgotPasswordForm: React.FC = observer(() => {
  const history = useHistory();

  const { forgotPasswordStatus, forgotPassword, authFormsIsLoading } =
    authStore;

  useStatusMessage(forgotPasswordStatus);

  const [isFocused, setIsFocused] = useState({
    email: false,
  });

  const {
    register,
    watch,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<IForgotPasswordForm>({ resolver: yupResolver(schema) });

  const watchAllField = watch();

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name } = e.target;
    setIsFocused({ ...isFocused, [name]: true });
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name } = e.target;

    if (watchAllField[name] !== "") {
      setIsFocused({ ...isFocused, [name]: true });
    } else {
      setIsFocused({ ...isFocused, [name]: false });
    }
  };

  const onSubmit = (data: IForgotPasswordForm) => {
    forgotPassword(data, history);
  };

  return (
    <div className={styles.positioning}>
      <LogoDarkLetters />
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <h1 className={styles.title}>Восстановление пароля</h1>
        </div>
        <form
          id="resetPw"
          className={`${styles.form} ${styles.forgotForm}`}
          onSubmit={handleSubmit(onSubmit)}
        >
          <FormField
            label={"Введите Email"}
            className={styles.email}
            name="email"
            register={register}
            type="text"
            error={errors?.email?.message}
            isRequired
            isFocused={isFocused.email}
            onFocus={handleFocus}
            onBlur={handleBlur}
          />
        </form>
        <div className={styles.footer}>
          <IButton variant="outlined" onClick={() => history.push("/login")}>
            Вернуться
          </IButton>
          <IButton
            form="resetPw"
            type="submit"
            disabled={authFormsIsLoading.value}
          >
            Отправить ссылку
          </IButton>
        </div>
      </div>
    </div>
  );
});
